export default __webpack_public_path__ + "static/protienIcon-8b1bbe30ac5611f2dff634ffb7e0ec93.png";